import get from 'lodash/get';
import {
  getDocumentFields,
  getFileUrl,
  getOptimizedContentfulImage,
} from 'utils/helper';

export const useFeaturesSection = ({ type, data }) => {
  const {
    contentModules,
    title,
    images,
    view,
    background,
  } = data;

  const imageUrl = getOptimizedContentfulImage(
    getFileUrl(get(images, '[0]')),
    { fm: 'png', fl: 'png8' },
  );

  const backgroundImageUrl = background ? getOptimizedContentfulImage(
    getFileUrl(background),
    { fm: 'png' },
  ) : null;

  const style = backgroundImageUrl ? { backgroundImage: `url(${backgroundImageUrl})` } : {};

  const featuresList = contentModules.map((feature) => {
    const { title: featureTitle, text } = getDocumentFields(feature);

    return {
      text,
      featureTitle,
    };
  });

  return {
    type,
    view,
    data,
    contentModules,
    title,
    imageUrl,
    featuresList,
    style,
    backgroundImageUrl,
  };
};
